import { useTranslation } from 'react-i18next';

import drawerConfig, { DrawerItem } from 'helpers/drawer-config';

/**
 * useTranslatedDrawerConfig
 *
 * This hook translates the drawer configuration items using the i18next translation library.
 * @returns {DrawerItem[]} Translated drawer configuration items.
 */
const useTranslatedDrawerConfig = (): DrawerItem[] => {
  const { t } = useTranslation('global');

  const translateConfig = (config: DrawerItem[]) =>
    config
      .map((item) => {
        const translatedItem = {
          ...item,
          title: t(item.key)
        };
        if (item.submenu) {
          translatedItem.submenu = translateConfig(item.submenu);
        }
        return translatedItem;
      })
      .sort((a, b) => a.title.localeCompare(b.title));

  return translateConfig(drawerConfig);
};

export default useTranslatedDrawerConfig;
